module.exports = __webpack_public_path__ + "img/osredm-logo-black-new.a50761bb.png";